import styled from '@emotion/styled';

export const SadaNotFound = styled.div``;
